import { FC, useState, useEffect } from 'react';
import { ChevronButton } from './Buttons/ChevronButton';
import React from 'react';

interface Props {
  uploadedDocumentPath: string | string[];
  fileUrl: string | string[];
  setShowOverlay: (value: React.SetStateAction<boolean>) => void;
  startingIndex?: number; // Relevant only for multi urls
}

export const ViewDocumentOverlay: FC<Props> = ({
  fileUrl,
  setShowOverlay,
  uploadedDocumentPath,
  startingIndex = 0,
}) => {
  const [currentIndex, setCurrentIndex] = useState(startingIndex);
  const [paths, setPaths] = useState<string[]>([]);
  const [urls, setUrls] = useState<string[]>([]);

  useEffect(() => {
    setPaths(Array.isArray(uploadedDocumentPath) ? uploadedDocumentPath : [uploadedDocumentPath]);
    setUrls(Array.isArray(fileUrl) ? fileUrl : [fileUrl]);
  }, [uploadedDocumentPath, fileUrl]);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % urls.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + urls.length) % urls.length);
  };

  return (
    <div className={`fixed inset-0 bg-gray-700 bg-opacity-50 flex items-center justify-center z-50`}>
      <div className="flex flex-col grow h-full items-center justify-center">
        <DocumentOverlayButtonSection
          handleNext={handleNext}
          handlePrev={handlePrev}
          isMultiUrl={urls.length > 1}
          setShowOverlay={setShowOverlay}
        />
        <div className="p-[0.5rem] shadow-md h-[70%] w-[50%] relative z-50">
          {paths[currentIndex]?.endsWith('.png') ||
          paths[currentIndex]?.endsWith('.jpeg') ||
          paths[currentIndex]?.endsWith('.jpg') ? (
            <img src={urls[currentIndex]} alt="Document" className="object-cover w-full h-full" />
          ) : (
            <object
              data={urls[currentIndex]}
              type="application/pdf"
              width="100%"
              height="100%"
              className="object-cover"
            >
              <p>Error Getting File</p>
            </object>
          )}
        </div>
      </div>
    </div>
  );
};

interface DocumentButtonProps {
  isMultiUrl: boolean;
  handlePrev: () => void;
  handleNext: () => void;
  setShowOverlay: (value: React.SetStateAction<boolean>) => void;
}

const DocumentOverlayButtonSection: React.FC<DocumentButtonProps> = ({
  handleNext,
  handlePrev,
  isMultiUrl,
  setShowOverlay,
}) => {
  return (
    <div className="flex flex-row gap-3">
      {isMultiUrl && (
        <div className="bg-white/50 rounded-full h-8 w-8 my-auto">
          <ChevronButton onButtonClick={handlePrev} direction="left" />
        </div>
      )}
      <button
        title="disable overlay"
        className="flex justify-center rounded-full bg-white/50  h-10 w-10 "
        onClick={() => setShowOverlay(false)}
      >
        <img className="h-[0.75rem] w-[0.75rem]  self-center  " src={`/assets/icons/flat/delete.svg`} alt="Close"></img>
      </button>
      {isMultiUrl && (
        <div className="bg-white/50  rounded-full h-8 w-8 my-auto">
          <ChevronButton onButtonClick={handleNext} />
        </div>
      )}
    </div>
  );
};
